import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../Tooltip/CustomTooltip';

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    padding: '5px 10px',
  }),
  control: () => ({
    // none of react-select's styles are passed to <Control />
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderBottom: '1px solid #848484',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  },
  menu: (provided, state) => ({
    ...provided,
    margin: '-1px 0 0 0',
    border: '1px solid #848484',
    borderRadius: 0,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    padding: 0,
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: '#000',
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    display: 'none',
  }),
};
function BtnSort({ onBtnClick, options, val, disable, placement }) {
  const { t } = useTranslation('common');

  return (
    <CustomTooltip placement="top" tooltipText="Sort">
      <button type="button" aria-label="Sort" className={val ? 'btn active' : 'btn'} disabled={disable}>
        <OverlayTrigger
          placement={placement || t('BTN_SORT.BUTTON')}
          trigger="click"
          rootClose
          overlay={
            <Popover className="custom-popover">
              <Popover.Content>
                <Select
                  options={options}
                  isClearable
                  value={val}
                  classNamePrefix="common-select"
                  className="common-select"
                  onChange={onBtnClick}
                  styles={customStyles}
                  placeholder={t('BTN_SORT.SORT_BY')}
                />
              </Popover.Content>
            </Popover>
          }
        >
          <i className="icon-Sort-By-Icon f-26" />
        </OverlayTrigger>
      </button>
    </CustomTooltip>
  );
}

export default BtnSort;
